import React from 'react';
import TextField from '@material-ui/core/TextField';

const InputComponent = (props) => {

    const {
        label = '',
        styles = {},
        parentStyles = { marginBottom: '15px' }
    } = props;
    return (<TextField
        id="standard-full-width"
        label={label}
        placeholder="Add Sub-category name"
        style={parentStyles}
        fullWidth={true}
        InputLabelProps={{
            shrink: true,
        }}
        inputProps={{
            style: {
                border: '1px solid grey',
                borderRadius: '20px',
                padding: '10px 20px',
                margin: '10px 0',
                background: 'none',
                ...styles
            }
        }}
        {...props}
    />)

}

export default InputComponent;